// Localização: frontend/src/pages/Financeiro/FinanceiroPage.jsx
// Página de Gestão Financeira

import React, { useEffect } from 'react';
import Title from '../../components/Layout/Title';
import CardSaldoContas from '../../components/Financeiro/CardSaldoContas';
import AcessoRapidoFinanceiro from '../../components/Financeiro/AcessoRapidoFinanceiro';
import { useDashboardFinanceiro } from '../../hooks/useFinanceiro';

const FinanceiroPage = () => {
    const { resumo, fetchResumo } = useDashboardFinanceiro();

    // Carregar dados do resumo ao montar o componente
    useEffect(() => {
        fetchResumo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="space-y-6 p-6 sm:p-8 lg:p-10">
            {/* Acesso Rápido às Funções */}
            <div className="mb-4">
                <AcessoRapidoFinanceiro />
            </div>
            
            <Title title="Gestão Financeira" />
            
            {/* Card de Saldo Total das Contas */}
            <div className="mb-6">
                <CardSaldoContas 
                    saldoTotal={resumo?.saldo_total_contas || 0}
                    contas={resumo?.contas_bancarias || []}
                />
            </div>
        </div>
    );
};

export default FinanceiroPage;

